import { Box } from "@chakra-ui/react";
import { Cell } from "../Cell";
import { Row } from "../Row";
import { DateCell } from "./Trend";
import { ResultCell } from "./Trend";
import React from "react";
import { StatsHelpModal } from "../HelpModal";
import { useBatchRenderedList } from "../../hooks/useBatchRenderedList";


export const Stats = ({dataList, patternFunc, ratioFunc, gameName}) => {
    const ReversedDataList = [...dataList].reverse()
    const batchList = useBatchRenderedList(ReversedDataList)

    return (
        <>
        <StatsHelpModal width="95%"/>
        
        <Box
            id="stats"
            overflow="auto"
            width="100%"
            maxHeight="77vh"
        >    
            <Box as="table">
                <Box as="thead" position="sticky" top="0" zIndex="2" bg="white"
                    boxShadow = "0px 1px 5px grey">
                    <Row>
                        <DateCell gameName={gameName}>Date</DateCell>
                        <ResultCell>Result</ResultCell>
                        <SumCell>Sum</SumCell>
                        <RangeCell>Range</RangeCell>
                        <PatternCell>Pattern</PatternCell>
                        <RatioCell>Ratio</RatioCell>
                    </Row> 
                </Box>
                <Box as="tbody">          
                    {batchList.map((data) => {
                        const results = data.results.map((result) => parseInt(result)).sort((a, b) => a - b)
                        return (
                            <Row key={data.issue_no}>
                                <DateCell gameName={gameName} date={data.end_time}/>
                                <ResultCell results={results}/>
                                <SumCell>{results.reduce((accumulator, currentValue) => accumulator + currentValue, 0)}</SumCell>
                                <RangeCell>{Math.max(...results) - Math.min(...results)}</RangeCell>
                                
                                <PatternCell>{patternFunc(results)}</PatternCell>
                                <RatioCell>{ratioFunc(results)}</RatioCell>
                            </Row> 
                        )
                    })}
                </Box>
            </Box>
        </Box>
        </>
    )
}




const SumCell = ({children, ...props}) => {
    return (
        <Cell
            className="sum_cell"
            width="50px"
            justify="center"
            {...props}
        >
            {children}
        </Cell>  
    )
}

const RangeCell = ({children, ...props}) => {
    return (
        <Cell
            className="range_cell"
            width="50px"
            justify="center"
            {...props}
        >
            {children}
        </Cell>  
    )
}

const PatternCell = ({children, ...props}) => {
    return (
        <Cell
            className="pattern_cell"
            width="70px"
            gap="2px"
            justify="center"
            {...props}
        >
            {children}
        </Cell>  
    )
}

export const PatternItem = ({children, ...props}) => {
    return (
        <Box
            as="span"
            className="pattern_item"
            width="14px"
            textAlign="center"
            {...props}
        >
            {children}
        </Box>  
    )
}

const RatioCell = ({children, ...props}) => {
    return (
        <Cell
            className="ratio_cell"
            width="50px"
            justify="center"
            {...props}
        >
            {children}
        </Cell>  
    )
}
